module.exports = __webpack_public_path__ + "img/album23_09.e77f52fb.jpg";